import styled from '@emotion/styled';
import { Variables } from '../variables';

export const Container = styled.div`
    width: 100%;
    border: 1px solid ${Variables.Colors.n15};
    border-radius: 4px;
    overflow: hidden;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    padding: 12px;
    cursor: pointer;
    user-select: none;
    background-color: ${Variables.Colors.n5};
    transition: background-color 0.2s ease;

    &:hover {
        background-color: ${Variables.Colors.n15};
    }
`;

export const Title = styled.div`
    flex: 1;
    font-size: 14px;
    font-weight: 600;
    color: ${Variables.Colors.n85};
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

export const ChevronIcon = styled.div<{ isOpen: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease;
    transform: ${props => props.isOpen ? 'rotate(90deg)' : 'rotate(0deg)'};
    color: ${Variables.Colors.n70};
`;

export const Content = styled.div<{ isOpen: boolean }>`
    max-height: ${props => props.isOpen ? '2000px' : '0'};
    overflow: hidden;
    transition: max-height 0.3s ease;
    padding: ${props => props.isOpen ? '12px' : '0'};
    border-top: ${props => props.isOpen ? `1px solid ${Variables.Colors.n15}` : 'none'};
`;

